// extracted by mini-css-extract-plugin
export default {"invalid":"SearchBarV2_invalid__gYW7u","shake":"SearchBarV2_shake__LFwoF"};